import { message } from 'antd';
import { fetchHomeFund, fetchFinanceList, editSponsorCostLimit, exportData, getExportStatus, killExportTask} from '../services/api';

export default {
  namespace: 'finance',

  state: {
    financeInfo: {},
    financeList: [],
    limit: '',
    loading: true,
    cashBalance: '',
    pointBalance: '',
    totalBalance: '',
    paginations: {
      totalCount: 1,
      currentPager: 1,
      limit: 20,
    },
  },

  effects: {
    *fetchInfo({callback}, { call, put }) {
      const response = yield call(fetchHomeFund);
      yield put({
        type: 'loadInfo',
        payload: response,
      });
      if (response) {
        callback(response);
      }
    },
    *fetchList({ payload } , { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(fetchFinanceList, payload);
      yield put({
        type: 'loadList',
        payload: response,
      });
      yield put({
        type: 'changeLoading',
        payload: false,
      });
    },
    *exportData({ payload, callback }, { call, put }) {
      const response = yield call(exportData, payload);
      yield put({
        type: 'saveTaskId',
        payload: response,
      });
      if (response) {
        callback(response);
      }
    },
    *getExportStatus({ payload, callback }, { call }) {
      const response = yield call(getExportStatus, payload);
      if (response) {
        callback(response);
      }
    },
    *killExportTask({ payload, callback }, { call }) {
      const response = yield call(killExportTask, payload);
      if (response) {
        callback(response);
      }
    },
    *limitSubmit({ callback,payload } , { call }) {
      const response = yield call(editSponsorCostLimit, payload);
      if (response) {
        message.success('提交成功');
      }
      callback();
    },
  },

  reducers: {
    loadInfo(state, action) {
      const financeInfo = { ...state.financeInfo, ...action.payload };
      return {
        ...state, financeInfo,
      }
    },
    loadList(state, action) {
      const financeList = action.payload.fundTransListVOTotalPager.list;
      const { 
        cashBalance, pointBalance, totalBalance,
        giftBalance, compensationBalance, nonGiftBalanceWithCash,
      } = action.payload;
      const paginations = {
        totalCount: action.payload.fundTransListVOTotalPager.totalCount,
        currentPager: action.payload.fundTransListVOTotalPager.currentPager,
        limit: action.payload.fundTransListVOTotalPager.limit,
      }
      return {
        ...state,
        financeList: Array.isArray(financeList) ? financeList : [],
        cashBalance: cashBalance || '',
        pointBalance: pointBalance || '',
        paginations,
        totalBalance: totalBalance || '',
        giftBalance: giftBalance || '',
        compensationBalance: compensationBalance || '',
        nonGiftBalanceWithCash: nonGiftBalanceWithCash || '',
      };
    },
    loadlimit(state, action) {
      return {
        ...state,
        limit: action.payload,
      };
    },
    changeLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },
};
